import {
  Component,
  OnInit,
  Input,
  ViewEncapsulation,
  Optional,
  Self,
  ViewChild,
  OnDestroy,
  AfterViewInit
} from '@angular/core';
import {FormGroup, NgControl} from '@angular/forms';
import { Item } from 'app/models/item.inferface';
import {BehaviorSubject, Subject} from 'rxjs';
import {BaseAnswerTypeComponent} from "../base-answer-type.component";
import {COMMA, ENTER} from "@angular/cdk/keycodes";
import {takeUntil} from "rxjs/operators";
import {ComparableOperator} from "../../../../models/form";
import { MatChipInputEvent } from '@angular/material/chips';

@Component({
  selector: 'app-text-list-input',
  templateUrl: './text-list-input.component.html',
  styleUrls: ['./text-list-input.component.scss'],
})
export class TextListInputComponent extends BaseAnswerTypeComponent<string[]> implements OnInit, OnDestroy, AfterViewInit {
  readonly separatorKeysCodes = [ENTER, COMMA] as const;
  @Input() placeholder: string = '';
  @Input() label: string;

  @ViewChild('chipList') chipList;

  private destroy$ = new Subject<void>();

  constructor(
    @Self()
    ngControl?: NgControl,
  ) {
    super(ngControl);
  }

  ngOnInit() {
  }

  ngAfterViewInit() {
    // listen for error (normally not necessary)
    this.ngControl.control.statusChanges
      .pipe(
        takeUntil(this.destroy$),
      )
      .subscribe(() => {
        if (this.chipList) {
          this.chipList.errorState = this.ngControl.invalid
        }
      });
  }

  remove(item: string) {
    this.setValue(this.value.filter(i => i !== item));
    this.onTouched();
  }

  add(event: MatChipInputEvent) {
    const value = (event.value || '').trim();

    // Add our fruit
    if (value) {
      this.setValue((this.value || []).concat(value));
    }

    // Clear the input value
    event.chipInput!.clear();
    this.onTouched();
  }

  ngOnDestroy() {
    this.destroy$.next(void 0);
  }

  AllowedOperators: {[K in ComparableOperator]: (t: string[], value: string) => boolean} = {
    [ComparableOperator.Equal]: null,
    [ComparableOperator.NotEqual]: null,
    [ComparableOperator.Contains]: null,
    [ComparableOperator.StartWith]: null,
    [ComparableOperator.EndWith]: null,
    [ComparableOperator.In]: null,
    [ComparableOperator.GreaterThan]: (t, value) => t?.length > +value,
    [ComparableOperator.GreaterThanOrEqual]: (t, value) => t?.length >= +value,
    [ComparableOperator.LessThan]: (t, value) => t?.length < +value,
    [ComparableOperator.LessThanOrEqual]: (t, value) => t?.length <= +value,
    [ComparableOperator.IsNullOrEmpty]: (target: string[]) => !(target?.length),
    [ComparableOperator.NotIsNullOrEmpty]: (target: string[]) => !! target?.length,
    [ComparableOperator.Between]: null,
    [ComparableOperator.Empty]: null,
    [ComparableOperator.Completed]: null,
  }

}
